import { createAction } from 'redux-act'

export const authInitiated = createAction('auth_initiated')
export const authFinished = createAction('auth_finished')
